import { Injectable } from '@angular/core';
import { rivetDelimiter } from '@rivethealth/data/delimiter';
import { AuthService } from '../../common/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class RecentOptionsService {
  constructor(private readonly auth: AuthService) {}

  private key(label: string) {
    return `select-dropdown-options:${this.auth.getUserId()}:${label}`;
  }

  getLocalLimited(label: string | null): string[] | null {
    return this.getLocal(label)?.slice(0, 5) || null;
  }

  getLocal(label: string | null): string[] | null {
    if (label) {
      const key = this.key(label);
      const saved = localStorage.getItem(key);
      if (saved?.includes(rivetDelimiter)) {
        return saved?.split(rivetDelimiter).slice(0, -1) ?? null;
      } else {
        return saved?.split(' ') ?? null;
      }
    }
    return null;
  }

  enqueue(id: string, label: string) {
    const recentIds = this.getLocal(label) ?? [];

    const inRecent = recentIds.indexOf(id);
    if (inRecent != -1) {
      recentIds.splice(inRecent, 1);
    }
    recentIds.unshift(id);

    while (recentIds.length > 100) {
      recentIds.pop();
    }

    if (recentIds.length > 0) {
      localStorage.setItem(
        this.key(label),
        recentIds.join(rivetDelimiter) + rivetDelimiter,
      );
    }
    return recentIds;
  }
}
